import { render } from "./AppPageTitle.vue?vue&type=template&id=0d5391c3"
import script from "./AppPageTitle.vue?vue&type=script&lang=js"
export * from "./AppPageTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__